<section class="recent-activity">
    <div class="container">
        <div class="row">
            <div class="col-md-8 col-10 title">
                <h2>Your Recent Activity </h2>
            </div>
            <div class="col-md-4 col-2 title text-right">
                <span class="d-sm-block">
                    <img src="assets/icon/clear.svg" width="25" height="25" (click)="closeSheet();crossBtnGA()"
                        style="cursor: pointer;" alt="close" />
                </span>
            </div>
            <div class="col-6 col-md-2 tier-card">
                <div class="box">
                    <img src="assets/icon/Solid Large.svg" alt="">
                    <h2>{{tierDetails.currentStarBalance}}</h2>
                    <p class="m-0">CURRENT STAR BALANCE</p>
                </div>
            </div>
            <div class="col-6 col-md-2">
                <div class="box">
                    <img src="assets/icon/stars2.svg" alt="">
                    <h2>{{tierDetails.starBalance}}</h2>
                    <p class="m-0">TOTAL STARS COLLECTED</p>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="container monthly-data">
        <div class="row">
            <div class="col-12">
                <div class="month-wise" *ngFor="let month of filteredData">
                    <h2 class="month">{{month.date}}</h2>
                    <div class="strip bg-img" [ngClass]="{ 'grey-bg': isOdd , 'mb-5' : islast }"
                        *ngFor="let item of month.list;odd as isOdd; even as isEven;last as islast">
                        <span class="dot"></span>
                        <div class="d-flex justify-content-between">
                            <h3 [ngClass]="{ 'green': !item.isRewardRedeemed && !item.isRewardExpired && redemptionDate == null ,'red': item.isRewardExpired && redemptionDate == null}">
                                <span *ngIf="item.rewardType == 'STARS'">
                                    <span *ngIf="item.isRewardRedeemed == false && item.isRewardExpired == false && redemptionDate == null">+</span>
                                    <span *ngIf="item.isRewardExpired && redemptionDate == null">-</span>
                                    {{item.starValue | number : '1.1-1'}}
                                </span>
                                <span class="star-icon"><img src="{{item.iconUrl}}" alt="star"></span>
                            </h3>
                            <h3>
                                <span *ngIf="item.isFreeDrink"><img src="{{item.freeDrinkIcon}}" alt="Free_drink"></span>
                            </h3>
                        </div>
                        <h5>{{item.subTitle}}</h5>
                        <h6 [ngClass]="{'red': item.isRewardExpired}">{{item.title}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
